import { AppState } from 'app-store'
import { getBuyFormState, getCheckoutState, getLabelContent } from '@buy/state/selectors'
import { buyUserActions } from '@buy/state/user/actions'
import { BuyFormData } from '@buy/state/buy-form/state'
import { buyFormActions } from '@buy/state/buy-form/actions'
import { getLocationState } from '@common/state/selectors'
import { BuyAccountFormInfoState } from './state'

export const mapBuyAccountFormInfoState = (state: AppState): BuyAccountFormInfoState => {
    const {
        createAnAccount,
        signIn,
        firstName,
        lastName,
        email,
        password,
        passwordRequirements,
        errorInvalidPassword,
        errorRequiredPassword,
        passwordStrength,
        passwordStrengthLevel1,
        passwordStrengthLevel2,
        passwordStrengthLevel3,
        passwordStrengthLevel4,
        passwordStrengthTipDrawer,
        passwordStrengthTip1,
        passwordStrengthTip2,
        passwordStrengthTip3,
        clicktoCancelCheckbox,
        clicktoCancelDisclaimer,
        year,
        month,
    } = getLabelContent(state)
    const { clearEmail, steps } = getBuyFormState(state)
    const { calculatedTax, finalTotal, billingTenure } = getCheckoutState(state)
    const { locationInfo } = getLocationState(state)
    const { currency, locale } = locationInfo

    return {
        content: {
            createAnAccount,
            signIn,
            firstName,
            lastName,
            email,
            password,
            passwordRequirements,
            clicktoCancelCheckbox,
            clicktoCancelDisclaimer,
            year,
            month,
        },
        errorContent: {
            errorInvalidPassword,
            errorRequiredPassword,
            passwordStrength,
            passwordStrengthLevel1,
            passwordStrengthLevel2,
            passwordStrengthLevel3,
            passwordStrengthLevel4,
            passwordStrengthTipDrawer,
            passwordStrengthTip1,
            passwordStrengthTip2,
            passwordStrengthTip3,
        },
        clearEmail,
        steps,
        calculatedTax,
        finalTotal,
        billingTenure,
        currency,
        locale,
    }
}

export const mapBuyAccountFormInfoActions = {
    checkExistingUser: (email: string, form?: BuyFormData) => buyUserActions.checkExistingUser(email, form),
    userLogin: (view: string, path?: string) => buyUserActions.userLogin(view, path),
    setEmailClear: (clear: boolean) => buyFormActions.setClearEmail(clear),
}

export type BuyAccountFormInfoActionsType = typeof mapBuyAccountFormInfoActions
